import { Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React from "react";

import FieldCreateEditCard from "./FieldCreateEditCard";
import { TooltipName } from "../../../../utils/Enums";
import { CustomButton } from "../../../../components/Button/Button";
import { useCreateCard } from "./hooks/useCreateCard";

function CreateCard({
  stage,
  isTodo = false,
  newCreatedCardId,
  isCreateCardFieldOpen,
  handleCreateCardClick,
  parentCardId = null,
  boardName,
}) {
  const {
    createBtnOpen,
    canShowCreateButton,
    closeCreateButton,
    handleKeyDown,
    isMobile,
    loading,
    openCreateButton,
    setTitle,
    title,
  } = useCreateCard({
    stage,
    isTodo,
    newCreatedCardId,
    isCreateCardFieldOpen,
    handleCreateCardClick,
    parentCardId,
    boardName,
  });

  return (
    <div style={isMobile ? { width: "100%" } : {}}>
      {createBtnOpen ? (
        <div
          style={{ marginBottom: "10px", width: isMobile ? "100%" : "auto" }}
        >
          <FieldCreateEditCard
            handleKeyDown={handleKeyDown}
            setTitle={setTitle}
            value={title}
            setCreateBtnOpen={closeCreateButton}
            preventCloseOnTabSwitch={true}
            loading={loading}
            disabled={loading}
          />
        </div>
      ) : (
        canShowCreateButton && (
          <div className="d-flex justify-content-end create-card-div">
            <Tooltip
              title={
                isTodo
                  ? TooltipName.BOARD_PAGE.CREATE_QUICK_TASK
                  : TooltipName.BOARD_PAGE.CREATE_TASK
              }
            >
              <CustomButton
                size="small"
                className="create-card-btn create-card-btn-bg reset-btn"
                onClick={openCreateButton}
              >
                <AddIcon className="create-card-btn-icon" />
              </CustomButton>
            </Tooltip>
          </div>
        )
      )}
    </div>
  );
}

export default CreateCard;
